import { Grid } from "@mui/material";
import CommonDialog from "../../common/commonDialog";
import { Card, CardBody } from "reactstrap";
import { Col } from "react-bootstrap";
import { useState } from "react";
import { formatMoney } from "../../../constants/utils";

const BalanceConfirmationReportModal = (props) => {
  const { open, onCancel, balanceConfirmationReportData, rowData } = props;

  return (
    <CommonDialog
      onCancel={onCancel}
      open={open}
      secondaryButtonLabel={"Cancel"}
      title={"Balance Confirmation Report"}
      maxWidth="lg"
    >
      <Grid container spacing={2}>
        <Col lg={12} xs={12}>
          <Card className="height-equal">
            <CardBody>
              <div className="user-status table-responsive text-center">
                <table className="table table-bordernone mb-20">
                  <thead>
                    <tr>
                      <th scope="col">Region</th>
                      <th scope="col">Total Customer</th>
                      <th scope="col">Total Closing Balance</th>
                      <th scope="col">Total Customer Balance</th>
                      <th scope="col">Total Difference</th>
                      <th scope="col">Approval Count</th>
                      <th scope="col">Pecentage</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{rowData.regionName}</td>
                      <td>{rowData.totalCount}</td>
                      <td>{formatMoney(rowData.totalCustomerBalance)}</td>
                      <td>{formatMoney(rowData.totalClosingBalance)}</td>
                      <td>{formatMoney(rowData.disagreedDifference)}</td>
                      <td>{rowData.approvedCount}</td>

                      <td>{rowData.percentage}</td>
                    </tr>
                  </tbody>
                </table>
                <hr></hr>
                <table className="table table-bordernone mb-0 mt-10">
                  <thead>
                    <tr>
                      <th scope="col">SNO</th>

                      <th scope="col">Customer</th>
                      <th scope="col">SAP Code</th>
                      <th scope="col">Closing Balance</th>
                      <th scope="col">Customer Balance</th>
                      <th scope="col">Difference if any</th>
                      <th scope="col">Financial Year</th>
                      <th scope="col">Quarter</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {balanceConfirmationReportData?.map((data, index) => (
                      <tr key={data.customerCode}>
                        <td>{index + 1}</td>

                        <td>{data.subParty}</td>
                        <td>{data.customerCode}</td>
                        <td>{formatMoney(data.closingBalance)}</td>
                        <td>
                          {data.status === "Agreed"
                            ? formatMoney(data.closingBalance)
                            : data.status === "Disagreed"
                            ? formatMoney(data.customerBalance)
                            : "-"}
                        </td>
                        <td>
                          {data.hasDifference
                            ? formatMoney(data.hasDifference)
                            : "-"}
                        </td>

                        <td>{data.financialYear}</td>
                        <td>{data.quarter}</td>
                        <td
                          style={{
                            color:
                              data.status === "Agreed"
                                ? "green"
                                : data.status === "Disagreed"
                                ? "red"
                                : "",
                            fontWeight:
                              data.status === "Agreed" ||
                              data.status === "Disagreed"
                                ? "bold"
                                : "",
                          }}
                        >
                          {data.status}
                        </td>

                        {/* <td>
                            <div>
                              <span>
                                <input
                                  type="checkbox"
                                  defaultChecked={data.approvalStatus === "Y"}
                                  onChange={(e) =>
                                    onApprovalStatusChange(e, index, data)
                                  }
                                />
                              </span>
                            </div>
                          </td> */}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Grid>
    </CommonDialog>
  );
};
export default BalanceConfirmationReportModal;
